<template lang="html">
  	<div class="footer">
  		<div class="downBar"></div>
  		<div class="container">
  			<div class="imgContainer"><img src="../../assets/img/down-logo.png"/></div>
  			<div class="copyright">
  				<div class="chinese">版权所有© 2018 国泰君安 </div>
				<div class="english">Copyright © 2018 Guotai Junan Futures Co.Ltd.,All Rights Reserved</div>
  			</div>
  		</div>
  	</div>
</template>
<script>
	export default {
	  	name: 'CommonHeader',
	}
</script>
<style lang="less" scoped>
	.footer{
		// position:fixed;
		// bottom:0;
		// left:0;
		width:100%;
		margin-top: 20px;
		// z-index: 11;
		.downBar{
			width:100%;
			height:20px;
			background-image:linear-gradient(90deg, #b7282e 0%, #ff5050 100%);
		}
		.container{
			background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
			width:100%;
			padding: 20px 40px;
			display: inline-block;
			.imgContainer{
				background:#ffffff;
				border-radius:10px;
				width:60px;
				height:60px;
				float: left;
				img{
					width:50px;
					margin-left:5px;
					margin-top:5px;
					display: block;
					vertical-align:bottom;
				}
			}
			.copyright{
				// float:left;
				position:relative;
				margin-left:80px;
				color:#ad8f5a;
				text-align:left;
				width:580px;
				.chinese{
					font-size:26px;
					letter-spacing:0.1px;
					height:30px;
					line-height: 30px;
				}
				.english{
					letter-spacing:0.1px;
					font-size:24px;
					margin-top:5px;
					-webkit-text-size-adjust:none;
					line-height: 24px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/commonFooter.vue